// The Constellation Panda theme set by `data-panda-theme` on <html>.
export const PANDA_THEME = 'hotpads-legacy';
